import { render, staticRenderFns } from "./ItemTextStats.vue?vue&type=template&id=54745b82&scoped=true&"
import script from "./ItemTextStats.vue?vue&type=script&lang=js&"
export * from "./ItemTextStats.vue?vue&type=script&lang=js&"
import style0 from "./ItemTextStats.vue?vue&type=style&index=0&id=54745b82&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54745b82",
  null
  
)

export default component.exports